module.exports = __webpack_public_path__ + "img/023-Politician.eef981e8.png";